<template>
  <!-- eslint-disable -->
  <div class="container-fluid">
    <div class="row header">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <p class="dg-header-label">Layout</p>
        <h1 class="dg-header">Overview</h1>
        <p>The specifications for our layout elements.</p>
      </div>
    </div>

    <div class="row content">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">

        <div class="row">
          <div class="col">
            <p>Choose from a responsive, fixed-width container (<span class="code">.container</span>) meaning its <span class="code">max-width</span> changes at each breakpoint or a fluid-width (<span class="code">.container-fluid</span>) meaning it’s <span class="code">100%</span> wide all the time.</p>
            <!--<p>Use <span class="code">.container-fluid</span> for a full width container, spanning the entire width of the viewport.</p>-->
          </div>
        </div>
        
        <div class="row mt-4">
          <div class="col">
            <p class="h3 dg-subheader">Code</p>
            
            <pre class="code-sample">
              <code class="html">
&lt;div class="container"&gt;
  Content here
&lt;/div&gt;

&lt;div class="container-fluid"&gt;
  Content here
&lt;/div&gt;</code>
            </pre>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col">
            <div class="row">
              <div class="col">
                <p class="h3 dg-subheader">Variants / Modifiers</p>   
              </div>
            </div>

            <div class="row">
              <div class="col">
                <p>Values of maximum width for <span class="code">.container</span> for different screen sizes.</p>
                <div class="var-sample">sm: 540px,<br/>
                  md: 720px,<br/>
                  lg: 960px,<br/>
                  xl: 1140px
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <p class="h4">Responsive Breakpoints</p>
                <p>Breakpoints are mostly based on minimum viewport widths and allow us to scale up elements as the viewport changes.</p>
                <p>Defined minimum dimensions at which the layout will change, adapting to different screen sizes, for use in media queries.</p>
                <div class="var-sample">
                  xs: 0,<br/>
                  sm: 576px,<br/>
                  md: 768px,<br/>
                  lg: 992px,<br/>
                  xl: 1200px
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>  
  </div>
  <!-- eslint-enable -->
</template>

<script>
export default {
  name: "Layout"
};
</script>

/* eslint-disable */
<style lang="sass?outputStyle=expanded">
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/routes/Layout.vue